import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { LombardFacade } from '@zero/lombard/domain';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { LombardFaqsComponent } from '../../components/lombard-faqs/lombard-faqs.component';
import { LombardInitialComponent } from '../../components/lombard-initial/lombard-initial.component';
import { LombardLegalComponent } from '../../components/lombard-legal/lombard-legal.component';
import { LombardStatusComponent } from '../../components/lombard-status/lombard-status.component';

@Component({
  templateUrl: './lombard-page.component.html',
  imports: [LombardInitialComponent, LombardFaqsComponent, LombardStatusComponent, LombardLegalComponent, AsyncPipe],
})
export class LombardPageComponent implements OnInit {
  public readonly facade = inject(LombardFacade);
  readonly #customerStateFacade = inject(CustomerStateFacade);

  ngOnInit(): void {
    this.#customerStateFacade.loadCustomerBaseData();
    this.facade.init();
  }
}
